import React from "react";
import {
  Table,
  TableContainer,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import TableHead from "./TableHead";
import TableBody from "./TableBody";
import TablePagination from "./TablePagination";
import TableToolbar from "./TableToolbar";

function TableCustom({
  children,
  columns,
  data,
  optionsPagination,
  optionsToolbar,
  width,
  heightBody,
  useLoading,
  loading,
  minHeightBody,
  marginTopPaper,
  elevationPaper,
  removeHeaderBackground,
  marginBorder,
  ativarHoverLinha = true,
  usarMarginBottomContainer = false,
  hideBorderBottom = false,
}) {
  return (
    <Paper elevation={elevationPaper ?? 1} style={{ width: "100%", marginTop: marginTopPaper || 0 }}>
      {optionsToolbar ? <TableToolbar {...optionsToolbar} /> : null}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: usarMarginBottomContainer ? 10 : 0 }}>
          <TableContainer
            style={{
              maxWidth: width || "100%",
              maxHeight: heightBody || "auto",
              minHeight: minHeightBody || "280px",
            }}
          >
            {useLoading && loading ? (
              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  maxHeight: heightBody || "auto",
                  minHeight: minHeightBody || "280px",
                }}
              >
                <CircularProgress size={70} />
              </div>
            ) : (
              <Table stickyHeader>
                {children ? (
                  children
                ) : (
                  <>
                    <TableHead
                      columns={columns}
                      data={data}
                      removeHeaderBackground={removeHeaderBackground}
                      hideBorderBottom={hideBorderBottom}
                    />
                    <TableBody
                      columns={columns}
                      ativarHoverLinha={ativarHoverLinha}
                      data={data}
                      marginBorder={marginBorder}
                      hideBorderBottom={hideBorderBottom}
                    />
                  </>
                )}
              </Table>
            )}
          </TableContainer>
      </div>
      {optionsPagination ? <TablePagination {...optionsPagination} /> : null}
    </Paper>
  );
}

export default TableCustom;
